import React from 'react'
import { Outlet } from 'react-router-dom'

import { PageLayout } from 'apps/aiAutomation/layout/PageLayout'
import { Ability } from 'common/core/constants/Ability'
import { useAbility } from 'common/core/hooks/useAbility'

export const AiAutomationLayout = () => {
  const aiAlwaysOnAbility = useAbility(Ability.AI_ALWAYS_ON)

  const isNavigationAvailable = aiAlwaysOnAbility.isEnabled

  if (isNavigationAvailable) {
    return (
      <PageLayout>
        <Outlet />
      </PageLayout>
    )
  }

  return <Outlet />
}
